import React, { useEffect } from "react";

const UnibotsPlayer = () => {
  useEffect(() => {
    // Ensure the global object exists
    window.unibots = window.unibots || { cmd: [] };

    // Dynamically load the Unibots script only on client side
    const script = document.createElement("script");
    script.src = "https://cdn.unibotscdn.com/teluguone/teluguone.js";
    script.async = true;
    document.body.appendChild(script);

    // Initialize player after script is loaded
    const initPlayer = () => {
      if (window.unibots && window.unibots.cmd) {
        window.unibots.cmd.push(() => {
          window.unibotsPlayer("teluguone");
        });
      }
    };

    script.onload = initPlayer;

    // Cleanup when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="div-ub-teluguone" />;
};

export default UnibotsPlayer;